import { Select } from "antd";
import styled from "styled-components";

const { Option } = Select;

export const CustomSelect = ({ options, placeholder, ...props }) => (
  <StyledSelect
    {...props}
    showSearch
    placeholder={placeholder}
    data-testid="select-option"
    virtual={false} // Disabled virtual scroll
    dropdownRender={(menu) => <StyledDropDown>{menu}</StyledDropDown>} // Used customized dropdown
    filterOption={(input, option) => {
      const optionLabel = option?.label?.toLowerCase() || "";
      const optionValue = option?.value?.toLowerCase() || "";

      return (
        optionLabel.includes(input.toLowerCase()) ||
        optionValue.includes(input.toLowerCase())
      );
    }}
  >
    <Option value="" disabled>
      {placeholder}
    </Option>
    {options.map((option) => (
      <Option key={option.code} value={option.code} label={option.name}>
        {option.name} ({option.code})
      </Option>
    ))}
  </StyledSelect>
);

const StyledSelect = styled(Select)`
  min-width: var(--input-min-width);
  width: 100%;

  @media (min-width: 600px) {
    max-width: 100%;
  }

  span.ant-select-selection-item {
    color: var(--dark-grey);
    font-family: var(--font-family);
    font-size: var(--body-font-size);
  }

  .ant-select-selector {
    border-color: var(--light-grey) !important;
    border-radius: 3px;
    transition: border-color 0.3s ease;
    box-shadow: none !important;

    &:hover {
      border: 1px solid var(--dropdown-hover-border-color) !important;
    }

    &:focus {
      border-color: red !important;
    }

    &.ant-select-focused {
      border-color: red !important;
      box-shadow: none !important;
      outline: none;
    }

    &:active {
      border: 2px solid var(--dropdown-activated-border-color) !important;
    }

    &.ant-select-status-error {
      border: 1px solid var(--dropdown-error-border-color) !important;
    }
  }
`;

const StyledDropDown = styled.div`
  max-height: 264px;
  overflow: hidden;
  overflow-y: auto;
`;
